import { SharingData } from '../../schema/SharingData';
import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

// For recipients can view/edit we permission each recipient individually on the server after send.
// This does not work for large dls, so we warn the user that recipients won't be given permission
export function cannotShareWithLargeDL(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): boolean {
    const hasLargeDL =
        recipientInfo.filter(recipient => {
            return recipient.totalMemberCount > 100;
        }).length > 0;
    return (
        hasLargeDL &&
        sharingData.sharingInfo &&
        (sharingData.currentPermissionLevel === AttachmentPermissionLevel.Edit ||
            sharingData.currentPermissionLevel === AttachmentPermissionLevel.View)
    );
}
